module.exports = __webpack_public_path__ + "460e7715f3b78e5d8fa74ccd35512923.fbx";